import React from 'react';
import * as styles from './Limit.css';
import { Select, UIText2 } from '@cian/ui-kit';

interface ILimitProps {
  limit: number;
  onChange: (limit: number) => void;
}

const OPTIONS = [
  { value: 10, label: '10' },
  { value: 20, label: '20' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
];

export const Limit: React.FC<ILimitProps> = ({ limit, onChange }) => {
  return (
    <div className={styles['container']}>
      <UIText2>Показывать по</UIText2>
      <Select options={OPTIONS} onChange={onChange} value={limit} placeholder="" />
    </div>
  );
};
